var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show"
            }
          ],
          staticClass: "alert-bg alert",
          class: _vm.alertType,
          attrs: { role: "alert" },
          on: { click: _vm.hideNow }
        },
        [
          _c("close-modal", { on: { click: _vm.hideNow } }),
          _vm._v(" "),
          _c("div", { staticClass: "alert-flash" }, [
            _c("div", { staticClass: "flash-content" }, [
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src:
                    "/img/icons/" +
                    _vm.network +
                    "/" +
                    _vm.icon +
                    (this.$root.is_mobile ? "-mobile" : "-desktop") +
                    ".svg",
                  height: "250",
                  width: "250"
                }
              }),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.exclamation))]),
              _vm._v(" "),
              _c("p", { domProps: { innerHTML: _vm._s(_vm.body) } })
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }